// extracted by mini-css-extract-plugin
export default {"container":"MaxLengthInput_container__XHSRb","switch":"MaxLengthInput_switch__mR3GJ","rules":"MaxLengthInput_rules__jum+e","title":"MaxLengthInput_title__+FPBx"};